// extracted by mini-css-extract-plugin
module.exports = {"tagsWrap":"MallItem_tagsWrap__AvKQL","discountTag":"MallItem_discountTag__SUbDN","activityTag":"MallItem_activityTag__hbfKV"};